//#region Imports

import {
    Component,
    EventEmitter,
    Injector,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';

import {Observable, skip, Subject} from 'rxjs';

import {appModuleAnimation} from '@axilla/axilla-shared';

import {SelectItem} from '@node_modules/primeng/api';
import {
    BasketArticleDto,
} from '@shared/service-proxies/service-proxies';
import {WebshopItemDetailsModalComponent} from '@app/webshop/shop/webshop-item-details-modal.component';
import {WebShopBaseComponent} from '@app/webshop/shared/common/webshop-base.component';
import {takeUntil, tap} from 'rxjs/operators';
import { ViewMode } from '../../models';

//#endregion Imports

@Component({
    selector: 'app-combine-view',
    templateUrl: './combine-view.component.html',
    styleUrls: ['./combine-view.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class CombineViewComponent extends WebShopBaseComponent implements OnInit, OnDestroy {

    @ViewChild('webshopItemDetails', { static: false }) webshopItemDetailsModal: WebshopItemDetailsModalComponent;

    @Output()
    loadData: EventEmitter<any> = new EventEmitter();

    @Output()
    onQuickAction: EventEmitter<any> = new EventEmitter();

    @Input() isSelectingArticles = false;
    @Input() showAdditionalFilters = false;
    @Input() hideSorting = false;
    @Input() hideSearch = true;

    layout: any;
    private viewMode$: Observable<ViewMode>;
    private items$: Observable<BasketArticleDto[]>;
    private totalAmount$: Observable<number>;

    private showOnlyInTrunk$: Observable<number>;

    globalProducts: BasketArticleDto[] | undefined = undefined;

    //Sorting option
    sortOrder: number;
    sortField: string;
    sortOptions: SelectItem[];

    constructor(
        injector: Injector
    ) {
        super(injector);

        // Initialize the observable to track the view mode
        this.viewMode$ = this._combineViewService.viewMode$;
        this.items$ = this._combineViewService.items$;
        this.totalAmount$ = this._combineViewService.totalAmount$;

        this.showOnlyInTrunk$ = this._combineViewService.showOnlyInTrunk$;
    }

    private _isLoading: any;

    get isLoading(): any {
        return this._isLoading;
    }

    set isLoading(value: any) {
        this._isLoading = value;
    }

    //#region ViewMode

    get viewMode(): ViewMode {
        return this._combineViewService.currentMode;
    }

    get isDataView(): boolean {
        return this._combineViewService.isDataView;
    }

    get isTableView(): boolean {
        return this._combineViewService.isTableView;
    }

    get isTileView(): boolean {
        return this._combineViewService.isTileView;
    }

    get isListView(): boolean {
        return this._combineViewService.isListView;
    }
    //#endregion ViewMode

    //#region Total Amount
    private _total = 0;

    // Getter for the `total` input property
    get total(): number {
        return this._total;
    }

    set total(value: number) {
        // Add logic to transform or validate input here
        this._total = value ? value : 0; // Default to an empty array if the value is falsy
    }
    //#endregion Total Amount

    registerEvents(): void {
        abp.event.on('app.globalSearch.run', () => {
            this.globalSearch();
        });

        abp.event.on('app.combineView.refresh', () => {
            this.loadData.emit();
        });
    }

    ngOnInit(): void {
        this.registerEvents();

        //init viewMode
        this.viewMode$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe((viewMode) => {
                //console.log('Current View Mode:', ViewMode[viewMode]);
            });
        //init items
        this.items$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe((items) => {
                this.globalProducts = items;
                //console.log('Current items:', items);
            });
        //init totalAmount
        this.totalAmount$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe((totalAmount) => {
                this.total = totalAmount;
                //console.log('Current totalAmount:', totalAmount);
            });

        if (this.isGuided) {
            this.showOnlyInTrunk$
                .pipe(
                    skip(1),
                    takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
                )
                .subscribe((value) => {
                    this.loadData.emit();
                });
        }

        //init products
        this.loadData.emit();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    openDetails(item: any) {
        abp.event.trigger('app.show.itemDetailModal', item);

        this.webshopService.updateArticleViewCounter(item);
    }

    onSortChange(value) {
        this.webshopService.onSortChange(value);
        this.onLoadData();
    }

    onLoadData($event?: any) {
        this.loadData.emit($event);
    }

    onClickQuickAction($event) {
        this.onQuickAction.emit($event);
    }
}

